import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useLojistaAuth } from "@/context/AuthContext";
import { LogoOrText } from "@/lib/logo";
import { Home, FileText, Hammer, LogOut, User, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import ErrorBoundary from "@/components/ErrorBoundary";

const TABS = [
  { to: "/lojista/dashboard", label: "Início", icon: Home, testid: "loj-nav-dashboard" },
  { to: "/lojista/meu-contrato", label: "Contrato", icon: FileText, testid: "loj-nav-contrato" },
  { to: "/lojista/obras", label: "Obras", icon: Hammer, testid: "loj-nav-obras" },
  { to: "/lojista/regimento", label: "Regimento", icon: BookOpen, testid: "loj-nav-regimento" },
];

export default function LojistaLayout() {
  const { lojista, logout } = useLojistaAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/lojista/login");
  };

  return (
    <div className="min-h-screen bg-background text-foreground pb-24">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-background/90 backdrop-blur-xl border-b border-border">
        <div className="max-w-md mx-auto px-5 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <LogoOrText className="h-9 max-w-[100px] flex-shrink-0" textClass="font-heading font-black text-sm flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-xs label-tag">Portal Lojista</div>
              <div data-testid="loj-header-razao" className="font-heading font-bold text-sm truncate break-anywhere">
                {lojista?.razao_social || "—"}
              </div>
            </div>
          </div>
          <Button
            data-testid="loj-logout-btn"
            onClick={handleLogout}
            variant="ghost"
            size="icon"
            className="rounded-full flex-shrink-0"
            aria-label="Sair"
          >
            <LogOut size={18} />
          </Button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-md mx-auto px-5 py-6">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur-xl border-t border-border">
        <div className="max-w-md mx-auto flex">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex-1 flex flex-col items-center gap-1 py-3 transition-colors duration-150
                  ${isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`
                }
              >
                {({ isActive }) => (
                  <>
                    <div className={`p-2 rounded-full ${isActive ? "bg-foreground text-background" : ""}`}>
                      <Icon size={18} strokeWidth={2} />
                    </div>
                    <span className="text-[10px] font-semibold uppercase tracking-widest">{t.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
